import { render, staticRenderFns } from "./JingquPingceCiyun.vue?vue&type=template&id=03352550&scoped=true&"
import script from "./JingquPingceCiyun.vue?vue&type=script&lang=js&"
export * from "./JingquPingceCiyun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03352550",
  null
  
)

export default component.exports